import React from "react";
import {
    Form as AntdForm,
    Button,
    Input,
    Space,
  } from "antd";
  import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
        
const GenerateGotsCertificate = () => {
    const [form] = AntdForm.useForm();
    // Handle form submission with typed values
  const handleSubmit = (values) => {
  };
    return (
        <div className="container mx-auto py-10">
            <h2 className="text-3xl md:text-4xl font-medium mb-2 text-center">
                GOTS Certificate Form
            </h2>
            <AntdForm
                form={form}
                onFinish={handleSubmit}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                layout="vertical"
                className="form_1 p-5 rounded-xl shadow-xl"
                style={{ maxWidth: 800, margin: "0 auto" }}
            >
          {/* <div className="flex items-center md:justify-between flex-wrap">
            
            <AntdForm.Item
              label="Scope Certificate Number"
              name="scope-certificate-number"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Scope Certificate Number" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Holder"
              name="holder"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Holder" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Version"
              name="version"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Version" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Certification Body"
              name="certification-body"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Certification Body" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Address"
              name="address"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Address" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Place and Date of Issue (YYYY-MM-DD)"
              name="place-and-date-of-issue"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Place and Date of Issue (YYYY-MM-DD)" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Last Updated"
              name="last-updated"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Last Updated" />
            </AntdForm.Item>
            <AntdForm.Item
              label="Wilford Lieber, CEO"
              name="certification-body"
              className="w-full md:w-[49%]"
            >
              <Input placeholder="Enter Certification Body" />
            </AntdForm.Item>
          </div> */}
                <h3 className="text-2xl pb-5">2. Products Appendix </h3>
                <div className="pb-5">
                    <AntdForm.List name="product-appendix">
                        {(fields, { add, remove }) => (
                            // <>
                            <AntdForm.Item required>
                                { fields.map(({ key, name, ...restField}, index) => (
                                <Space
                                    key={key}
                                    style={{ display: "flex", marginBottom: 8 }}
                                    align="baseline"
                                >
                                    <div className="pb-5">
                                    <div className="flex md:justify-between flex-wrap">
                                        <AntdForm.Item
                                            {...restField}
                                            label="Product Number"
                                            name={[name, "product-number"]}
                                            className="w-full md:w-[49%]"
                                        >
                                            <Input placeholder="Enter Product Number" />
                                        </AntdForm.Item>
                                        <AntdForm.Item
                                            {...restField}
                                            label="Product Category - Product Details"
                                            name={[name, "product-category-product-details"]}
                                            className="w-full md:w-[49%]"
                                        >
                                            <Input placeholder="Enter Product Category - Product Details" />
                                        </AntdForm.Item>
                                    </div>
                                    <div className="flex md:justify-between flex-wrap">
                                        <AntdForm.Item
                                            {...restField}
                                            label="Material Composition"
                                            name={[name, "material-composition"]}
                                            className="w-full md:w-[49%]"
                                        >
                                            <Input placeholder="Enter Material Composition" />
                                        </AntdForm.Item>
                                        <AntdForm.Item
                                            {...restField}
                                            label="Standard (Label Grade)"
                                            name={[name, "standard"]}
                                            className="w-full md:w-[49%]"
                                        >
                                            <Input placeholder="Enter Standard (Label Grade)" />
                                        </AntdForm.Item>
                                    </div>
                                    </div>
                                    {fields.length > 1 && (
                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                    )}
                                </Space>
                                ))
                                }

                                <AntdForm.Item>
                                    <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                    >
                                    Add field
                                    </Button>
                                </AntdForm.Item>
                            </AntdForm.Item>
                            // </>
                        )}
                    </AntdForm.List>
                </div>
          {/*----------------------------------------------------- submit -----------------------------------------------------*/}
        <AntdForm.Item>
          <Button htmlType="submit">
            Submit
          </Button>
        </AntdForm.Item>
            </AntdForm>
     
        </div>
    )
};

export default GenerateGotsCertificate;
